import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Utah = () => {
  return (
    <StatePropertyTaxPage
      stateName="Utah"
      processDescription="Property owners may appeal their assessment by filing with the county board of equalization within 45 days of receiving notice. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="August"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in August with the annual tax notice."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Utah assesses property as of January 1 each year. This assessment date captures the property's market value and condition at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners have 45 days from receiving the notice to file appeals with the county board of equalization. This typically results in a September deadline."
    />
  );
};

export default Utah;